export const BASE_SELECTOR: string = '[data-supportcenter]';
export const FILTER_SELECTOR: string = '[data-supportcenter-filter] button'
export const CLOSED_SELECTOR: string = "[data-status='closed']";
export const OPEN_SELECTOR: string = "[data-status='answered'], [data-status='open']";

export enum FilterType {
  all,
  open,
  closed
}

export class SupportUI {
  public constructor(private $base: JQuery) {}

  public onFilter(callback: (filter: FilterType) => void)  {
    this.$base.find(FILTER_SELECTOR).on('click', (e) => {
      const val: string = e.currentTarget.textContent;
      switch (val.toLocaleLowerCase()) {
        case 'all':
          this.$base.find(FILTER_SELECTOR).removeClass('is-active');
          e.currentTarget.classList.add('is-active');
          callback(FilterType.all);
          break;
        case 'open':
          this.$base.find(FILTER_SELECTOR).removeClass('is-active');
          e.currentTarget.classList.add('is-active');
          callback(FilterType.open);
          break;
        case 'closed':
          this.$base.find(FILTER_SELECTOR).removeClass('is-active');
          e.currentTarget.classList.add('is-active');
          callback(FilterType.closed);
          break;
      }
    });
  }

  public toggleTableRows(type: FilterType) {
    if (type === FilterType.all) {
      this.$base.find(CLOSED_SELECTOR).show();
      this.$base.find(OPEN_SELECTOR).show();
    }
    else if (type === FilterType.closed) {
      this.$base.find(CLOSED_SELECTOR).show();
      this.$base.find(OPEN_SELECTOR).hide();
    } else {
      this.$base.find(CLOSED_SELECTOR).hide();
      this.$base.find(OPEN_SELECTOR).show();
    }
  }
}

export function createSupportInstances(): SupportUI[] {
  const instances : SupportUI[] = [];
  $(BASE_SELECTOR).each((index, element) => {
    instances.push(new SupportUI($(element)));
  });
  return instances;
}
